module.exports = {"id":"s3-q1","text":"Do you have any Social Media accounts?","multiselect":false,"options":[{"id":"s3-q1-a1","text":"Yes","capability":1,"baseline":2,"access":1,"next":"s3-q2","focusarea":[0,3,2,2,2]},{"id":"s3-q1-a2","text":"No","next":"s4-q1","capability":-1,"access":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dlrq/questions/s3-q1.json
// module id = 913
// module chunks = 32